import React from "react";

import { useUser } from "../../api/hooks/defs/user";

/** Resolves and renders an employee's name from their id (person-field condition values store only the id). */
export const EmployeeName = ({ employeeId }: { employeeId: string }) => {
	const { data: user } = useUser({ userID: employeeId });
	return <>{user?.name ?? ""}</>;
};
